import React, { FunctionComponent } from 'react';

import { Modal } from 'components';
import { Text, List, ListItem, Icon, Heading } from 'components/chroma';

import { replaceSpaces } from 'scenes/common/helpers/text';

export const INCLUDED_ITEMS = [
  'Jewellery and watches',
  'Laptop computers, mobile phones and tablets',
  'Cameras, photographic equipment and accessories',
  'Handbags, purses and wallets, excluding their contents',
  'Hearing aids, wheel chairs and mobility devices',
];
export const NOT_INCLUDED_ITEMS = [
  'CDs, DVDs, films, audio or video tapes',
  'Handheld computer games, toys or hobby equipment',
  'Items used for business trade or professional purpose',
  'Cash, credit or debit cards, negotiable instruments or documents',
  'Photographic equipment whilst being used underwater',
];

const UnspecifiedPortableContentsModal: FunctionComponent<{
  isOpen: boolean;
  onClose: () => void;
}> = ({ isOpen, onClose }) => (
  <Modal
    header="Which portable contents can be covered?"
    isOpen={isOpen}
    onClose={onClose}
  >
    <Heading size={2} margin={{ top: 6 }}>
      Items that are covered include:
    </Heading>
    <List>
      {INCLUDED_ITEMS.map((item) => (
        <ListItem key={replaceSpaces(item)}>
          <Icon name="check" margin={{ right: 5 }} />
          <Text>{item}</Text>
        </ListItem>
      ))}
    </List>

    <Heading size={2} margin={{ top: 6 }}>
      Items that are NOT covered include:
    </Heading>
    <List>
      {NOT_INCLUDED_ITEMS.map((item) => (
        <ListItem key={replaceSpaces(item)}>
          <Icon name="times" margin={{ right: 5 }} />
          <Text>{item}</Text>
        </ListItem>
      ))}
    </List>
  </Modal>
);

export default UnspecifiedPortableContentsModal;
